import PortalTooltip from '../../common/PortalTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { IconButton } from '@mui/material';
import { Time } from '../../common/MomentTime';

//θ(1) Returns all the columns of the datagrid
export const getColumns = ({ id, onEdit, onDelete }) => {
  return [
    {
      field: 'Actions',
      headerName: 'Actions',
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      resizable: false,
      renderCell: (params) => {
        return (
          <>
            <PortalTooltip id={`${id}__tooltip_edit`} title={'Edit'}>
              <IconButton id={`${id}__iconButton_edit`} onClick={() => onEdit(params.row)}>
                <FontAwesomeIcon
                  id={`${id}__icon_edit`}
                  size="xs"
                  icon={faPen}
                  style={{ color: 'black' }}
                />
              </IconButton>
            </PortalTooltip>
            <PortalTooltip id={`${id}__tooltip_delete`} title={'Delete'}>
              <IconButton id={`${id}__iconButton_delete`} onClick={() => onDelete(params.row)}>
                <FontAwesomeIcon
                  id={`${id}__icon_delete`}
                  size="xs"
                  icon={faTrashAlt}
                  style={{ color: 'black' }}
                />
              </IconButton>
            </PortalTooltip>
          </>
        );
      },
    },
    {
      field: 'ID',
      headerName: 'Codecs ID',
      flex: 1,
    },
    {
      field: 'SYSTEM_NAME',
      headerName: 'System Name',
      flex: 1,
    },
    {
      field: 'CREATED_AT',
      headerName: 'Created At',
      width: 200,
      valueFormatter: (value) => {
        return value ? Time.University(value).format('MMMM D, YYYY, h:mm A') : '-';
      },
    },
    {
      field: 'UPDATED_AT',
      headerName: 'Updated At',
      width: 200,
      valueFormatter: (value) => {
        return value ? Time.University(value).format('MMMM D, YYYY, h:mm A') : '-';
      },
    },
  ];
};
